module.exports = __webpack_public_path__ + "img/action-collect-active.9a9e521d.svg";